/*
 * @Author: Ryan
 * @Date: 2026-01-14
 * @Description: CTA section - Ready to Create AI Videos
 */
import React from 'react';

import StartButton from './StartButton';

const CTASection: React.FC = () => {
  return (
    <section className="w-full bg-[#0A0A0A] py-[80px] pad:py-[100px] sm:py-[120px] px-4 pad:px-8 sm:px-[65px]">
      <div className="max-w-[1190px] mx-auto text-center">
        {/* Title */}
        <h2 className="text-2xl pad:text-3xl sm:text-[42px] font-bold text-white mb-4 pad:mb-6 leading-tight">
          Your Next Video Ready in Seconds
        </h2>

        {/* Description */}
        <p className="text-sm pad:text-base sm:text-base text-gray-400 max-w-4xl mx-auto mb-8 pad:mb-10 sm:mb-12 leading-relaxed">
          Skip filming and editing. Turn ideas into smooth, high-quality videos in just a
          few clicks. Create multiple versions and go from concept to final output—fast.
        </p>

        {/* CTA Button */}
        <StartButton text="Create Your Video Now" />
      </div>
    </section>
  );
};

export default CTASection;
